export default __webpack_public_path__ + "static/media/textimage.656bec02.png";